import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { createField } from "./featureAPI";

const initialState = {
  loading: "idle",
  designation: "",
  image: [],
  status: "idle",
  fields: [],
  field: {
    images: [],
    id: "",
    designation: "",
  },
  allFields: {
    fields: [],
    totalCount: 0,
    totalPages: 0,
    currentPage: 1,
  },
};

export const addField = createAsyncThunk("featureField/addField", async (data: any) => {
  return await createField.add(data);
});

export const fetchFields = createAsyncThunk("featureField/fetchField", async () => {
  return await createField.verify();
});
export const fetchFieldByid = createAsyncThunk("featureField/fetchFieldByid", async (id: any) => {
  return await createField.getById(id);
});
export const deleteField = createAsyncThunk("featureField/deleteField", async (id: number) => {
  return await createField.delete(id);
});

export const updateField = createAsyncThunk(
  "featureField/editField",
  async ({ data, id }: { data: any; id: any }) => {
    return await createField.update(data, id);
  }
);

export const adminGetAllFields = createAsyncThunk(
  "adminGetAllFields",
  async ({ page, searchTerm }: { page: number; searchTerm: string }) => {
    return await createField.adminGetAllFields(page, searchTerm);
  }
);

const createFieldSlice = createSlice({
  name: "featureField",
  initialState,
  reducers: {
    setDesignation(state, action) {
      state.designation = action.payload;
    },
    setImage(state, action) {
      state.image = action.payload;
    },
    resetDesignation(state) {
      state.designation = "";
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(adminGetAllFields.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(adminGetAllFields.fulfilled, (state, action) => {
        state.allFields = {
          fields: action.payload.fields || [],
          totalCount: action.payload.totalCount || 0,
          totalPages: action.payload.totalPages || 0,
          currentPage: action.payload.currentPage || 1,
        };
        state.loading = "succeeded";
      })
      .addCase(adminGetAllFields.rejected, (state, action) => {
        state.loading = "failed";
      });
    builder
      .addCase(addField.pending, (state) => {
        state.status = "loading";
      })
      .addCase(addField.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.designation = action.payload;
        state.image = action.payload;
      })
      .addCase(addField.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(fetchFields.fulfilled, (state, action) => {
        state.fields = action.payload;
      })
      .addCase(fetchFieldByid.fulfilled, (state, action) => {
        state.field = action.payload;
      })
      .addCase(deleteField.pending, (state) => {
        state.status = "pending";
      })
      .addCase(deleteField.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(deleteField.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(updateField.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateField.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.designation = action.payload;
      })
      .addCase(updateField.rejected, (state) => {
        state.status = "failed";
      });
  },
});

export const { setDesignation, resetDesignation, setImage } = createFieldSlice.actions;
export default createFieldSlice.reducer;
